import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiFileText, FiRefreshCw } from "react-icons/fi";

import Reveal from "../../../components/ui/Reveal";

export default function PagePublicNotFound({ error, onRefresh }) {
  return (
    <main className="mx-auto max-w-[900px] px-4 pb-16 pt-10 sm:px-6">
      <Reveal>
        <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white px-6 py-12 text-center shadow-sm dark:border-slate-700 dark:bg-slate-950">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-[#1277B9]/10 text-[#1277B9] dark:bg-[#1277B9]/20 dark:text-sky-300">
            <FiFileText className="h-7 w-7" />
          </div>

          <h1 className="mt-5 text-2xl font-bold text-slate-950 dark:text-white md:text-3xl">
            Page introuvable
          </h1>

          <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-slate-600 dark:text-slate-300">
            La page demandée n’existe pas, n’est pas publiée ou n’est plus
            disponible.
          </p>

          {error && (
            <p className="mt-3 text-sm font-semibold text-red-600 dark:text-red-300">
              Une erreur est survenue pendant le chargement.
            </p>
          )}

          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-900"
            >
              <FiArrowLeft className="h-4 w-4" />
              Retour à l’accueil
            </Link>

            <button
              type="button"
              onClick={onRefresh}
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-[#1277B9] px-5 text-sm font-bold text-white shadow-sm transition hover:bg-[#0f659d]"
            >
              <FiRefreshCw className="h-4 w-4" />
              Réessayer
            </button>
          </div>
        </div>
      </Reveal>
    </main>
  );
}